/**
 * SelectedFloorsDisplay Component
 * Displays selected floors with markers positioned on them
 */

import { __ } from '@wordpress/i18n';
import FloorImage from './FloorImage';
import useFloorData from './UseFloorData';
import useMarkerEffect from './UseMarkerEffect';

const SelectedFloorsDisplay = ({ selectedFloors }) => {
    // Get floor data from API
    const { floorData, isLoading, error } = useFloorData(selectedFloors);

    // Add markers to floor images
    useMarkerEffect(isLoading, selectedFloors, floorData);

    // Handle loading state
    if (isLoading) {
        return <p>{__('Loading floor data...')}</p>;
    }

    // Handle error state
    if (error) {
        return <p className="error-message">{error}</p>;
    }

    // Handle empty state
    if (!selectedFloors || selectedFloors.length === 0) {
        return (
            <p>{__('No floors selected. Use the block settings to add floors.')}</p>
        );
    }

    // Render each floor in a separate container
    return (
        <div className="selected-floors-preview">
            {selectedFloors.map((floor) => {
                const floorId = floor.floorId;
                const floorPost = floorData[floorId];

                return (
                    <div key={floorId} className="floor-item-container">
                        <FloorImage floorId={floorId} floorPost={floorPost} />
                    </div>
                );
            })}
        </div>
    );
};

export default SelectedFloorsDisplay;
